module.exports = __webpack_public_path__ + "static/media/prick_HMPG_header_image_04_1000.ce5aa8d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_header_image_04_1000.jpg
// module id = 346
// module chunks = 0